import React, { memo, useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert, AlertColor } from "@mui/material";

interface RpSnackbarProps {
  message?: React.ReactNode;
  severity?: AlertColor;
  show?: boolean;
}

const RpSnackbar = ({ message, severity = "error", show }: RpSnackbarProps) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (show) {
      setOpen(show);
    }
  }, [show]);
  const handleClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert
        onClose={handleClose}
        severity={severity}
        elevation={6}
        variant="filled"
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default memo(RpSnackbar);
